module.exports = __webpack_public_path__ + "main/images/learnmore/firefox-color-logo.54ac2ee2db7680ff1e7d549f3881faf1.svg";